import useServicePageContent from './useServicePageContent';
import { getServicePageDefaults } from '../data/servicePagesSeed';

/** CMS content for a service page (hero + intro); body layout stays in React components. */
export default function useServicePageCms(slug) {
  return useServicePageContent(slug, getServicePageDefaults(slug));
}
